import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NotifyService } from '@app/services';
import { ReportFilter } from '../../interfaces/report-filter.interface';
import { Report } from '../../services/queries/report';

@Component({
    templateUrl: './employee-documents-report.view.html',
    styleUrls: ['./employee-documents-report.style.scss'],
})
export class EmployeeDocumentsReportView {
    isLoading = false;
    report: Report;
    filters: ReportFilter[];

    constructor(
        public route: ActivatedRoute,
        protected notify: NotifyService
    ) {
        this.report = this.route.snapshot.data.report;
    }

    onExport(contentType: string): void {
        this.report.export(contentType).catch(() => {
            this.notify.error('Error exporting employee documents report');
        });
    }
}
